import { Button } from "@mui/material";
import type { ButtonProps } from "@mui/material";

export interface AppButtonProps extends Omit<ButtonProps, "color"> {
    tone?: "primary" | "secondary" | "ghost" | "navy" | "destructive" | "ai";
}

export const AppButton = ({ tone = "primary", sx, ...rest }: AppButtonProps) => {
    switch (tone) {
        case "ai":
            return (
                <Button
                    {...rest}
                    variant="contained"
                    sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        color: "secondary.main",
                        border: "2.5px solid transparent",
                        borderRadius: 999,
                        backgroundImage:
                            "linear-gradient(#fff, #fff), linear-gradient(90deg, #6C63FF, #C24BFF, #FF6AC2)",
                        backgroundOrigin: "border-box",
                        backgroundClip: "padding-box, border-box",
                        boxShadow: "none",
                        transition: "box-shadow 0.2s ease, filter 0.2s ease",
                        "&:hover": {
                            filter: "brightness(0.97)",
                            boxShadow: "0 0 8px rgba(150, 90, 255, 0.35)",
                        },
                        ...sx,
                    }}
                />
            );
        case "secondary":
            return (
                <Button
                    {...rest}
                    variant="contained"
                    sx={{
                        backgroundColor: "secondary.light",
                        color: "secondary.dark",
                        "&:hover": {
                            backgroundColor: (theme) => theme.palette.secondary.light,
                            filter: "brightness(0.96)",
                        },
                        ...sx,
                    }}
                />
            );
        case "ghost":
            return (
                <Button
                    {...rest}
                    variant="text"
                    sx={{
                        color: "text.primary",
                        backgroundColor: "transparent",
                        "&:hover": {
                            backgroundColor: "action.hover",
                        },
                        ...sx,
                    }}
                />
            );
        case "navy":
            return (
                <Button
                    {...rest}
                    variant="contained"
                    sx={{
                        backgroundColor: "text.primary",
                        color: "common.white",
                        "&:hover": {
                            backgroundColor: "text.primary",
                            filter: "brightness(0.92)",
                        },
                        ...sx,
                    }}
                />
            );
        case "destructive":
            return <Button {...rest} variant="contained" color="error" sx={sx} />;
        case "primary":
        default:
            return <Button {...rest} variant="contained" color="primary" sx={sx} />;
    }
};
